var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-5",attrs:{"flat":""}},[_c('timeline',{attrs:{"setup":_vm.setup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }